import React, { useEffect, useMemo } from 'react';
import { FILTER_KEYS } from 'cards/components/CardListing/CardListingRedesign/CardListingFilter/constants';
import { existenceCheck } from 'cards/components/CardListing/CardListingRedesign/utils';
import { CommonFilterProps } from './types';
import { SideDrawer } from './FilterSideDrawer.style';
import { FilterSideDrawerHeader } from './FilterSideDrawerHeader';
import { FilterSideDrawerContent } from './FilterSideDrawerContent';
import { FilterSideDrawerFooter } from './FilterSideDrawerFooter';
import { FilterKey } from '../../FilterTypes';

interface FilterSideDrawerProps extends CommonFilterProps {
  filterMenuList: any[];
  onClose: () => void;
  clearFilters: () => void;
  searchTotal: number;
}

export const FilterSideDrawer: React.FC<FilterSideDrawerProps> = ({
  activeFilter,
  filterMenuList,
  onClose,
  clearFilters,
  updateFilter,
  searchTotal,
  searchFilters,
}) => {
  useEffect(() => {
    const HTMLTag = document.documentElement;
    HTMLTag.style.overflow = activeFilter !== null ? 'hidden' : '';

    return () => {
      HTMLTag.style.overflow = '';
    };
  }, [activeFilter]);

  const hasActiveFilters = useMemo(() => {
    const filterKeys = Object.keys(FILTER_KEYS) as Array<FilterKey>;

    return filterKeys.some(filter => {
      const currentValue = searchFilters[filter];
      return existenceCheck(currentValue);
    });
  }, [searchFilters]);

  return (
    <SideDrawer displayDrawer={activeFilter !== null} onClose={onClose}>
      {{
        header: FilterSideDrawerHeader,
        content: (
          <FilterSideDrawerContent
            activeFilter={activeFilter}
            filterMenuList={filterMenuList}
            updateFilter={updateFilter}
            searchFilters={searchFilters}
          />
        ),
        footer: ({ handleClose }) => (
          <FilterSideDrawerFooter
            hasActiveFilters={hasActiveFilters}
            onClear={clearFilters}
            onClose={handleClose}
            searchTotal={searchTotal}
          />
        ),
      }}
    </SideDrawer>
  );
};
